export const rsMainServices = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "MAIN SERVICE TRENCHING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Water main trenching",
    Qty: "2061",
    Unit: "m",
    Rate: "19.43",
    Amount: "£40,045.23",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Electric LV main trenching",
    Qty: "2450",
    Unit: "m",
    Rate: "17.73",
    Amount: "£43,438.50",
  },
  {
    Item: "",
    Description: "Electric HV main trenching to substation",
    Qty: "385",
    Unit: "m",
    Rate: "17.73",
    Amount: "£6,826.05",
  },
  {
    Item: "",
    Description: "Substation base",
    Qty: "1",
    Unit: "nr",
    Rate: "9834.53",
    Amount: "£9,834.53",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Gas main trenching",
    Qty: "2953",
    Unit: "m",
    Rate: "17.73",
    Amount: "£52,356.69",
  },
  {
    Item: "",
    Description: "Gas governor base",
    Qty: "1",
    Unit: "it",
    Rate: "5527.50",
    Amount: "£5,527.50",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "BT main ducting",
    Qty: "",
    Unit: "m",
    Rate: "15.18",
    Amount: "",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104",
    Qty: "",
    Unit: "nr",
    Rate: "468.33",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104C 750mm deep",
    Qty: "",
    Unit: "nr",
    Rate: "1023.09",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 106D 900 deep",
    Qty: "",
    Unit: "nr",
    Rate: "1168.82",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 106 1200 deep",
    Qty: "",
    Unit: "nr",
    Rate: "1538.66",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104 (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "787.92",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 104C 750mm deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1156.76",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 106D 900 deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1328.61",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 106 1200 deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1752.72",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Fibre main ducting",
    Qty: "2434",
    Unit: "m",
    Rate: "15.18",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Footway Box FW4",
    Qty: "",
    Unit: "nr",
    Rate: "828.12",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Footway Box FW6",
    Qty: "",
    Unit: "nr",
    Rate: "1150.73",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Footway Box FW10",
    Qty: "",
    Unit: "nr",
    Rate: "1802.97",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Streetlighting main",
    Qty: "",
    Unit: "m",
    Rate: "17.73",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Streetlight connection pits",
    Qty: "27",
    Unit: "nr",
    Rate: "539.69",
    Amount: "£14,571.63",
  },
  {
    Item: "",
    Description: "Streetlights & columns",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Road crossing duct n ex 150mmØ",
    Qty: "2095",
    Unit: "m",
    Rate: "58.37",
    Amount: "£122,285.15",
  },
  {
    Item: "",
    Description: "EO for 225mmØ duct",
    Qty: "16",
    Unit: "m",
    Rate: "18.52",
    Amount: "£296.32",
  },
  {
    Item: "",
    Description: "EO for 300mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "40.81",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "EO for 450mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "103.93",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "EO for 600mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "135.68",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "EO for excavating service trenches off site in 'live' footway",
    Qty: "279",
    Unit: "m",
    Rate: "175.88",
    Amount: "£49,070.52",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "LV Diversion",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Electric LV main trenching - excavate, sand bed & surround, backfill with as dug",
    Qty: "130",
    Unit: "m",
    Rate: "17.73",
    Amount: "£2,304.90",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£346,557.02",
  },
];
